import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import TitleFrom from '../../../../components/common/TitleFrom';
import {
  uploadMultiPartFiles,
  saveOutputTemplateByType,
  getOutputTemplateByType,
  getPACProductCodesConfig,
  getTaxTypeConfigSelect,
} from '../../../App/actions';
import { TaxExemptionSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportTaxExemption, sortTaxExemption } from '../../constants';
import { getTaxExemptionReport, getAllListTaxExemption } from '../../actions';
import { makeGetListTaxExemption, makeGetListAllTaxExemption } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class TaxExemption extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listTaxExemptions: [],
    emails: [],
    taxCodeOptions: [],
    taxTypesOptions: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listTaxExemptions: props.listTaxExemptions,
      totalCount: getPageTotalCount({ ...state, items: props.listTaxExemptions }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeExemtionReport },
      getPACProductCodesConfig,
      getTaxTypeConfigSelect,
    } = this.props;
    if (modeExemtionReport) {
      this.dogetTaxExemptionReport();
      this.doGetOutputTemplateByType();
      getPACProductCodesConfig({ page: 1, size: 500 }, ({ success, data }) => {
        if (success && data && data.length) {
          const taxCodeOptions = data.map(val => ({
            label: `${val.id} (${val.description})`,
            value: val.id,
          }));
          this.setState({ taxCodeOptions });
        }
      });
      getTaxTypeConfigSelect('', ({ success, data }) => {
        if (success && data && data.taxTypes) {
          const taxTypesOptions = data.taxTypes.map(val => ({
            label: val.code,
            value: val.code,
          }));
          this.setState({ taxTypesOptions });
        }
      });
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.dogetTaxExemptionReport();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.dogetTaxExemptionReport());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.dogetTaxExemptionReport());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.dogetTaxExemptionReport();
    });
  };

  dogetTaxExemptionReport = () => {
    const { filter, page, size, sorted } = this.state;
    const { getTaxExemptionReport } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortTaxExemption[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getTaxExemptionReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAllTaxExemption = cb => {
    const { filter, sorted } = this.state;
    const { getAllListTaxExemption } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortTaxExemption[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllListTaxExemption(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAllTaxExemption(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllTaxExemption, t } = this.props;
        convertJson2Pdf({
          data: listAllTaxExemption,
          t,
          title: t('reportPage:sidebar.taxExemption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.taxExemption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAllTaxExemption(() => {
      const { listAllTaxExemption, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;
      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'TAX_EXEMPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.taxExemption')}`,
          emailBody,
        },
        ['type']
      )})}"}`;

      const formData = new FormData();
      formData.append('graphql', query);
      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.taxExemption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllTaxExemption,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { accountType: 'accountType' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllTaxExemption,
          t,
          title: t('reportPage:sidebar.taxExemption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.taxExemption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.taxExemption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('TAX_EXEMPTION_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportTaxExemption,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listTaxExemptions,
      emails,
      isOpenModalExportConfig,
      exportColumnsSave,
      taxCodeOptions,
      taxTypesOptions,
    } = this.state;
    const {
      listAllTaxExemption,
      t,
      permissions: { modeExemtionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeExemtionReport) return '';

    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.taxExemption') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.taxExemption')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <TaxExemptionSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  isMultipleOptionInject
                  optionsInject={{
                    productCode: taxCodeOptions,
                    taxType: taxTypesOptions,
                  }}
                />
              </div>
              <div>
                <div className="mt-3 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.taxExemption').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllTaxExemption,
                          t,
                          title: t('reportPage:sidebar.taxExemption').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.taxExemption')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listTaxExemptions}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listTaxExemptions && listTaxExemptions.length ? listTaxExemptions : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

TaxExemption.propTypes = {};

TaxExemption.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  listTaxExemptions: makeGetListTaxExemption() || [],
  listAllTaxExemption: makeGetListAllTaxExemption() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getTaxExemptionReport,
    getAllListTaxExemption,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    getPACProductCodesConfig,
    getTaxTypeConfigSelect,
  })(TaxExemption)
);
